import type { NuxtApp } from '#app'

export default abstract class BaseApi {
  protected readonly app: NuxtApp
  protected readonly artistAggregatorBaseUrl: string
  protected readonly imageBaseUrl: string
  protected readonly craftBaseUrl: string
  constructor(app: NuxtApp) {
    this.app = app
    this.artistAggregatorBaseUrl = app.$config.public.api.artistAggregator
    this.imageBaseUrl = app.$config.public.api.image
    this.craftBaseUrl = app.$config.public.api.craft
  }
}
